import { Fragment } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { FormattedPriceCalculationResponse } from "../constants";
import { usePriceFinderStore } from "../store/store";

import { centerJustifiedStyling } from "./card-container";
import { PriceDisplay } from "./price-display";

const monthlyContainerStyles = css(centerJustifiedStyling);

const team24PerUserTextCss = css({
    fontSize: "14px",
    lineHeight: "24px",
    height: "48px"
});

export type MonthlyTeam24Props = {
    readonly priceCalc: FormattedPriceCalculationResponse;
    readonly fontSize: string;
    readonly planName: string;
};

export const MonthlyTeam24 = ({
    priceCalc,
    fontSize,
    planName
}: MonthlyTeam24Props) => {
    const { formattedAvgPerUnitPrice } = priceCalc;
    const [{ messages }] = usePriceFinderStore();

    return (
        <Fragment>
            <PriceDisplay
                planName={planName}
                formattedPrice={formattedAvgPerUnitPrice}
                fontSize={fontSize}
            />
            <div css={monthlyContainerStyles}>
                <div css={team24PerUserTextCss}>
                    <FormattedMessage {...messages.cardMonthlyPerUnitCount} />
                </div>
            </div>
        </Fragment>
    );
};
